<template>
  <div style="margin: 0px; padding: 0px;">
    <el-container direction="vertical" class="layout-container">
      <HEAD :active="active"></HEAD>
      <el-main class="el-main-ms">
        <!--图片层-->
        <main-plugin :img-src="imgSrc"></main-plugin>
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
      <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import MainPlugin from "@/components/MainPlugin";
import ContactPlugin from "@/components/ContactPlugin";
export default {
  name: "ContactWe",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '关于陌上酒店'
    },{
      name: 'description',
      content: '关于陌上酒店'
    }]
  },
  data() {
    return {
      active: '7',
      imgSrc: require('../assets/images/cp-pg.jpg')
    }
  },
  components: {
    HEAD,
    FOOT,
    MainPlugin,
    ContactPlugin
  }
}
</script>

<style scoped>

</style>
